import { FC } from 'react';
import { Spinner } from '@fluentui/react-components';
import css from './VerticallyAlignedSpinner.module.scss';

interface VerticallyAlignedSpinnerProps {
  description: string;
}

export const VerticallyAlignedSpinner: FC<VerticallyAlignedSpinnerProps> = ({ description }) => {
    return (
        <Spinner className={css.alignVertically} label={description} />
    );
};